import { Type, TemplateRef } from "@angular/core"
import { Observable } from "rxjs"

export interface ModalOptions<T = unknown> {
  data: T
  layoutColor: string | undefined
  backgroundColor: string | undefined
  cssClass: string | string[] | undefined
  padding: string | number | [number, number] | [number, number, number] | [number, number, number, number] | undefined
  width: number | undefined
  height: number | undefined
  minWidth: number | undefined
  minHeight: number | undefined
  maxWidth: number | undefined
  maxHeight: number | undefined
  showDisableAds: boolean
  showClose: boolean
  fullscreen: boolean
  destroyOnLayoutClick: boolean
  beforeClose?: () => boolean | Observable<boolean>
  afterClose?: () => void
}

export const defaultModalOptions: ModalOptions<undefined> = {
  data: undefined,
  layoutColor: undefined,
  backgroundColor: undefined,
  cssClass: undefined,
  padding: undefined,
  width: undefined,
  height: undefined,
  minWidth: undefined,
  minHeight: undefined,
  maxWidth: undefined,
  maxHeight: undefined,
  showDisableAds: false,
  showClose: true,
  fullscreen: false,
  destroyOnLayoutClick: true,
}

export type ModalContent = Type<unknown>|TemplateRef<unknown>|string

export interface ModalInputs<T = unknown> {
  id: number
  content: ModalContent
  options: ModalOptions<T>
}

export interface ModalEvent {
  show: boolean
}
